// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/spinnerloader/index.scss
// module id = 2169
// module chunks = 13